import tippy from 'tippy.js';
import {IS_DESKTOP} from '../constants';

tippy('[data-tippy-content]', {
	animation: 'shift-toward-subtle',
	placement: 'bottom',
	trigger: IS_DESKTOP ? 'mouseenter focus' : 'click',
});

const tooltips = document.querySelectorAll('[data-tooltip]');

if (tooltips) {
    [...tooltips].forEach((tooltip) => {
        tippy('[data-tippy-html]', {
            allowHTML: true,
            interactive: true,
            content: tooltip.innerHTML
        })
    });
}
